import axios from "axios";
import Api from "../api.js";

// Create an Axios instance with default configuration
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "1",
  },
});

// Define your service functions
const DashboardServices = {
  statasticsApi: () => {
    return apiClient.get(`/dashboard/statastics`);
  },
};

export default DashboardServices;
